import { useCallback, useContext, useEffect, useState } from "react"
import styles from "./index.module.scss"
import API, { commonApiInvoker } from '@api/api';
import { GenerateContext } from "../../../hooks/GenerateContext";
import eventBus from "@utils/eventBus";
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import SelectionColorItem from "../SelectionColorItem";

const ColorSelection = (props) => {
    const {
        colorKeyList, setColorKeyList
    } = useContext(GenerateContext)
    const {
        drawerOpen,
        onDrawerOpen,
        onDrawerClose
    } = props

    const recentColorList = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
    const showRecent = recentColorList.length > 0
    // 收藏列表
    const [favoriteList, setFavoriteList] = useState([])
    const showFavorite = favoriteList.length > 0
    // 刷新
    const [force, updateForce] = useState()

    // 刷新收藏列表
    const updateFavoriteColor = useCallback(() => {
        updateForce({})
    }, [])

    // 刷新收藏列表
    useEffect(() => {
        eventBus.on('update_favorite_color', updateFavoriteColor)
        return () => {
            eventBus.off('update_favorite_color', updateFavoriteColor) // 支付弹窗
        }
    }, [])

    // 刷新收藏列表
    useEffect(() => {
        // 需要登录
        if (!localStorage.getItem('token')) return
        commonApiInvoker(API.getFavoriteColors()).then(res => {
            setFavoriteList(res??[])
        })
    }, [force])

    return (
        <>
        {
            showRecent && (
                <div className={styles.ColorSelectionItem}>
                    <p className={styles.Title}>
                        <span>最近使用</span>
                    </p>
                    <div className={styles.Content}>
                    {
                        recentColorList.map((item, index) => (
                            <div key={item + index} style={{width:40}}>
                                <SelectionColorItem
                                    record={{
                                        name: item,
                                        color: item,
                                    }}
                                    showName={false}
                                    showFavor={false}
                                    onClick={() => setColorKeyList([item])}
                                    actived={item === colorKeyList[0]}
                                />
                            </div>
                        ))
                    }
                    </div>
                </div>
            )
        } {
            showFavorite && (
                <div className={styles.ColorSelectionItem}>
                    <p className={styles.Title} style={{cursor:"pointer"}} onClick={drawerOpen ? onDrawerClose : onDrawerOpen}>
                        <span>我的收藏</span>
                        {drawerOpen ? <LeftOutlined /> : <RightOutlined />}
                    </p>
                    <div className={styles.Content}>
                        {
                            favoriteList.map((item, index) => (
                                <div key={item.color + index} style={{width:40}}>
                                    <SelectionColorItem
                                        record={{
                                            name: item.name,
                                            color: item.color,
                                        }}
                                        showName={false}
                                        showFavor={false}
                                        onClick={() => setColorKeyList([item.color])}
                                        actived={item.color === colorKeyList[0]}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </div>
            )
        }
        </>
    )
}

export default ColorSelection